module.exports = __webpack_public_path__ + "static/media/link_outer.1cf7df57.svg";